<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="false"
            :pullDownLabel="false"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                    </div>
                    <van-dropdown-menu>
                        <van-dropdown-item
                            v-model="searchForm.dateType"
                            :options="dateTypeOptions"
                            @change="handleClickDateChange"
                        />
                    </van-dropdown-menu>
                    <div class="work_order_statistics_container mobile_container">
                        <div class="statistics_item_wrap">
                            <div class="item_card_wrap">
                                <p>{{ allChartData.newCreateNum > 999 ? "999+" : allChartData.newCreateNum }}</p>
                                <p>新增</p>
                            </div>
                            <div class="item_card_wrap">
                                <p>{{ allChartData.processingNum > 999 ? "999+" : allChartData.processingNum }}</p>
                                <p>进行中</p>
                            </div>
                            <div class="item_card_wrap">
                                <p>{{ allChartData.finishNum > 999 ? "999+" : allChartData.finishNum }}</p>
                                <p>已关闭</p>
                            </div>
                        </div>
                        <div class="statistics_flex_wrap">
                            <div class="item_card_wrap">
                                <p>{{ allChartData.noAssignNum > 999 ? "999+" : allChartData.noAssignNum }}</p>
                                <p>待分配</p>
                            </div>
                            <div class="item_card_wrap">
                                <p>{{ allChartData.noTravelNum > 999 ? "999+" : allChartData.noTravelNum }}</p>
                                <p>待到达</p>
                            </div>
                        </div>
                        <div class="chart_box_item chart_box_item1">
                            <p class="chart_box_item_title">新增工单类型分布</p>
                            <div class="chart_box_item_bottom">
                                <div class="echarts_container" id="container2"></div>
                            </div>
                        </div>
                        <div class="chart_box_item chart_box_item2">
                            <p class="chart_box_item_title">新增工单趋势图</p>
                            <div class="chart_box_item_bottom">
                                <div class="echarts_container" id="container1"></div>
                            </div>
                        </div>
                        <div class="chart_box_item chart_box_item3">
                            <p class="chart_box_item_title">工单类型实施工作量占比</p>
                            <div class="chart_box_item_bottom">
                                <div class="echarts_container" id="container4"></div>
                            </div>
                        </div>
                        <div class="chart_box_item chart_box_item4">
                            <p class="chart_box_item_title">实施人员工作量（天/人）</p>
                            <div class="chart_box_item_bottom">
                                <div class="echarts_container" id="container3"></div>
                            </div>
                        </div>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                </div>
            </template>
        </PullContainer>
        <!--日期区间选择-->
        <van-calendar
            :allow-same-day="true"
            :min-date="dateCalendarMin"
            :max-date="dateCalendarMax"
            @close="showCustomDatePopper = false"
            @confirm="handleClickRangeCalendarConfirm"
            color="#1990FF"
            type="range"
            v-model="showCustomDatePopper"
        >
        </van-calendar>
    </div>
</template>
<script>
import { workOrderCharts } from "@/api";
import { formatDate, getNowDate, getDateRange } from "@/utils";
import * as echarts from "echarts";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
export default {
    name: "WorkOrderStatisticsReport",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
    },
    data() {
        return {
            searchForm: {
                dateTypeName: "日报表",
                dateType: "day",
                customDate: [getNowDate(), getNowDate()],
            },
            dateTypeOptions: [
                {
                    text: "日报表",
                    value: "day",
                },
                {
                    text: "周报表",
                    value: "week",
                },
                {
                    text: "月报表",
                    value: "month",
                },
                {
                    text: "季度报表",
                    value: "quarter",
                },
                {
                    text: "年报表",
                    value: "year",
                },
                {
                    text: "自定义时间",
                    value: "customDate",
                },
            ],
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            showCustomDatePopper: false,
            allChartData: {
                newCreateNum: 0, // 新增工单数
                processingNum: 0, // 进行中工单数
                finishNum: 0, // 已完结工单数
                noAssignNum: 0, // 待分配工单数
                noTravelNum: 0, // 待出发工单数
                newCreateList: [], // 新增工单趋势图
                typeList: [], // 新增工单类型分布
                userDuration: [], // 实施人员工作量(天)
                typeDuration: [], // 工单类型实施工作量占比
                durationTotal: 0, // 总工时(用于 工单类型实施工作量 占比计算)
            },
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "WorkOrder",
                    title: "工单",
                },
                {
                    icon: "icon-zhuzhuangtu",
                    activeIcon: "icon-zhuzhuangtu",
                    routerName: "WorkOrderStatisticsReport",
                    title: "统计报表",
                },
                {
                    icon: "icon-rili",
                    activeIcon: "icon-rili",
                    routerName: "WorkOrderStatisticsCalendar",
                    title: "日历",
                },
                {
                    icon: "icon-gantetu",
                    activeIcon: "icon-gantetu",
                    routerName: "WorkOrderStatisticsGanttChart",
                    title: "甘特图",
                },
            ],
            tabBarActive: 1,
        };
    },
    mounted() {
        this.getWorkOrderCharts();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.handleClickSearch();
            }
        },
        handleClickDateChange() {
            const type = this.searchForm.dateType;
            if (type !== "customDate") this.showCustomDatePopper = false;
            if (type === "day") {
                this.searchForm.customDate = [getNowDate(), getNowDate()];
            } else if (type === "week") {
                this.searchForm.customDate = getDateRange("week").split(" - ");
            } else if (type === "month") {
                this.searchForm.customDate = getDateRange("month").split(" - ");
            } else if (type === "quarter") {
                this.searchForm.customDate = getDateRange("quarter").split(" - ");
            } else if (type === "year") {
                this.searchForm.customDate = getDateRange("year").split(" - ");
            } else if (type === "customDate") {
                this.showCustomDatePopper = true;
            }
            if (type !== "customDate") {
                this.getWorkOrderCharts();
            }
        },
        handleClickRangeCalendarConfirm(range) {
            const [start, end] = range;
            let value = [formatDate(start, "date"), formatDate(end, "date")];
            this.searchForm.customDate = value;
            this.showCustomDatePopper = false;
            this.getWorkOrderCharts();
        },
        handleClickSearch() {},
        getWorkOrderCharts() {
            this.loading = true;
            const params = {
                date: this.searchForm.customDate,
            };
            workOrderCharts(params)
                .then((res) => {
                    if (res.code === 200) {
                        const data = res.data || {};
                        this.allChartData = data;
                        this.getWorkOrderAdd(data.newCreateList || []);
                        this.getWorkOrderTypeData(data.typeList || []);
                        this.getWorkDaysData(data.userDuration || []);
                        this.getWorkLoadData(data.typeDuration || []);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取新增工单趋势图
        getWorkOrderAdd(data) {
            this.getLineData(data, "新增工单数量");
        },
        // 新增工单类型分布
        getWorkOrderTypeData(data) {
            this.getPieData("container2", data, "单数占比", "单");
        },
        // 获取实施人员工作量（天/人）
        getWorkDaysData(data) {
            this.getBarData(data, "工作天数");
        },
        // 工单类型实施工作量占比
        getWorkLoadData(data) {
            this.getPieData2("container4", data, "工作时长占比", "小时");
        },
        getLineData(data, tooltipName) {
            let xData = data.map((item) => item.created_date);
            let sData = data.map((item) => item.count);
            var charts = document.getElementById("container1");
            var myChart = echarts.getInstanceByDom(charts);
            if (myChart) {
                myChart.dispose();
            }
            this.getEchartsLine("container1", xData, sData, tooltipName);
        },
        getEchartsLine(id, xData, sData, tooltipName) {
            var dom = document.getElementById(id);
            this.myChartLine = echarts.init(dom);
            this.myChartLine.clear();
            var color = ["#1890ff", "#52C41B", "#FBAD13", "#FF4D4F", "#00BAAD"];
            var option;
            option = {
                color,
                grid: {
                    left: "10px",
                    top: "20px",
                    right: "10px",
                    bottom: "16px",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "line", // 默认为直线，可选为：'line' | 'shadow'
                        lineStyle: {
                            color: "#E8E8E8",
                            width: 0.5,
                        },
                    },
                    triggerOn: "mousemove", // 鼠标移动时触发 tooltip
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    // position: function (point, params, dom, rect, size) {
                    //     return [  point[0], point[1]];
                    // },
                    formatter: function (params) {
                        const paramsData = params[0];
                        let html = `<div class="custom_chart_tooltip"><p class="tooltip_title">${
                            paramsData.name
                        }</p><p class="tooltip_content"><span>${tooltipName}</span><span class="count">${
                            paramsData.data + "单"
                        }</span></p></div>`;
                        return html;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                        color: "#000000FF",
                    },
                },
                yAxis: {
                    type: "value",
                    name: "新增工单数量", // 设置 x 轴标题
                    nameLocation: "middle", // 标题显示位置，默认是 'end'
                    nameGap: 20, // 标题与轴线之间的距离
                    nameTextStyle: {
                        // 标题样式
                        color: "rgba(153, 153, 153, 1)",
                        fontSize: 12,
                    },
                    // interval: 1,
                    min: 0,
                    scale: true, // 允许动态缩放
                    axisLine: {
                        show: false,
                    },
                    splitLine: {},
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(102, 102, 102, 1)",
                    },
                },
                series: [
                    {
                        data: sData,
                        type: "line",
                    },
                ],
                dataZoom: [
                    {
                        type: "slider", // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                        bottom: 0,
                        height: 15,
                        handleSize: "100%", // 滑块手柄的大小
                        handleStyle: {
                            color: "#000",
                            shadowBlur: 3,
                            shadowColor: "rgba(0, 0, 0, 0.6)",
                            shadowOffsetX: 2,
                            shadowOffsetY: 2,
                        },
                    },
                    {
                        type: "inside", // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                    },
                ],
            };
            if (option && typeof option === "object") {
                this.myChartLine.setOption(option, true);
            }
            this.handleResizeLine();
            window.addEventListener("resize", this.handleResizeLine);
        },
        getBarData(data, tooltipName) {
            let xData = data.map((item) => (item.processing_user && item.processing_user.name) || "未知");
            let sData = data.map((item) => item.duration);
            var charts = document.getElementById("container3");
            var myChart = echarts.getInstanceByDom(charts);
            if (myChart) {
                myChart.dispose();
            }
            this.getEchartsBar("container3", xData, sData, tooltipName);
        },
        getEchartsBar(id, xData, sData, tooltipName) {
            var dom = document.getElementById(id);
            this.myChartBar = echarts.init(dom);
            this.myChartBar.clear();
            var color = ["#1890ff", "#52C41B", "#FBAD13", "#FF4D4F", "#00BAAD"];
            var option;
            option = {
                color,
                grid: {
                    left: "10px",
                    top: "20px",
                    right: "10px",
                    bottom: "16px",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    triggerOn: "mousemove", // 鼠标移动时触发 tooltip
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    // position: function (point, params, dom, rect, size) {
                    //     return [  point[0], point[1]];
                    // },
                    formatter: function (params) {
                        let html = `<div class="custom_chart_tooltip"><p class="tooltip_title">${
                            params.name
                        }</p><p class="tooltip_content"><span>${tooltipName}</span><span class="count">${
                            params.data + "天"
                        }</span></p></div>`;
                        return html;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                        color: "#000000FF",
                    },
                },
                yAxis: {
                    type: "value",
                    name: "天数", // 设置 x 轴标题
                    nameLocation: "middle", // 标题显示位置，默认是 'end'
                    nameGap: 15, // 标题与轴线之间的距离
                    nameTextStyle: {
                        // 标题样式
                        color: "rgba(153, 153, 153, 1)",
                        fontSize: 12,
                    },
                    min: 0, // 设置最小值
                    scale: true, // 允许动态缩放
                    axisLine: {
                        show: false,
                    },
                    splitLine: {},
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(102, 102, 102, 1)",
                    },
                },
                series: [
                    {
                        data: sData,
                        type: "bar",
                    },
                ],
                dataZoom: [
                    {
                        type: "slider", // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                        bottom: 0,
                        height: 15,
                        handleSize: "100%", // 滑块手柄的大小
                        handleStyle: {
                            color: "#000",
                            shadowBlur: 3,
                            shadowColor: "rgba(0, 0, 0, 0.6)",
                            shadowOffsetX: 2,
                            shadowOffsetY: 2,
                        },
                    },
                    {
                        type: "inside", // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                    },
                ],
            };
            if (option && typeof option === "object") {
                this.myChartBar.setOption(option, true);
            }
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        // 根据图表数据量返回颜色
        getChartColor(count) {
            if (count > 5) {
                if (count > 10) {
                    return [
                        "#4488E2",
                        "#2E7DD9",
                        "#16ABA1",
                        "#3FBA70",
                        "#5AB333",
                        "#9ECF36",
                        "#EB821A",
                        "#F0AA32",
                        "#DEAC07",
                        "#E8A30E",
                        "#D9345A",
                        "#E44144",
                        "#A522BD",
                        "#A97BE9",
                        "#7143DE",
                        "#7486C8",
                        "#7072D7",
                        "#646F9D",
                        "#7A96ED",
                        "#5BB5B2",
                    ];
                }
                return [
                    "#2990FF",
                    "#2E7DD9",
                    "#16ABA1",
                    "#5AB333",
                    "#9ECF36",
                    "#F0AA32",
                    "#DEAC07",
                    "#E44144",
                    "#A522BD",
                    "#7143DE",
                ];
            }
            return ["#2990FF", "#16ABA1", "#5AB333", "#F0AA32", "#E44144"];
        },
        getPieData(id, list, tooltipName, labelTooltipName) {
            let sData = [];
            let sData2 = [];
            const color = [
                "#2990FF",
                "#F0AA32",
                "#5AB333",
                "#16ABA1",
                "#2E7DD9",
                "#9ECF36",
                "#DEAC07",
                "#E44144",
                "#A522BD",
                "#7143DE",
            ];
            list.forEach((item, index) => {
                const s_item = {
                    name: item.workorder_type_name,
                    value: item.count,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        position: "outside",
                        formatter: `{circle|c}{name|{b}}\n{count|${item.count}${labelTooltipName}}\n`,
                        labelLine: {
                            length: 20,
                        },
                        rich: {
                            count: {
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.45)",
                                padding: [0, 0, 0, 11],
                            },
                            name: {
                                padding: [0, 0, 0, 5],
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.65)",
                            },
                            circle: {
                                width: 6,
                                height: 6,
                                backgroundColor: color[index],
                                borderRadius: 5,
                                color: "rgba(255,255,255,0)",
                            },
                        },
                    },
                };
                const s_item2 = {
                    name: item.workorder_type_name,
                    value: item.count,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        normal: {
                            show: true,
                            position: "inner", // 数值显示在内部
                            formatter: "{d}%",
                            color: "#ffffff",
                        },
                    },
                };
                sData.push(s_item);
                sData2.push(s_item2);
            });
            this.getEchartsPie(id, sData, sData2, color, tooltipName);
        },
        getPieData2(id, list, tooltipName, labelTooltipName) {
            let sData = [];
            let sData2 = [];
            const color = [
                "#2990FF",
                "#F0AA32",
                "#5AB333",
                "#16ABA1",
                "#2E7DD9",
                "#9ECF36",
                "#DEAC07",
                "#E44144",
                "#A522BD",
                "#7143DE",
            ];
            list.forEach((item, index) => {
                const s_item = {
                    name: item.workorder_type_name,
                    value: item.duration,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        position: "outside",
                        formatter: `{circle|c}{name|{b}}\n{count|${item.duration}${labelTooltipName}}\n`,
                        labelLine: {
                            length: 20,
                        },
                        rich: {
                            count: {
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.45)",
                                padding: [0, 0, 0, 11],
                            },
                            name: {
                                padding: [0, 0, 0, 5],
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.65)",
                            },
                            circle: {
                                width: 6,
                                height: 6,
                                backgroundColor: color[index],
                                borderRadius: 5,
                                color: "rgba(255,255,255,0)",
                            },
                        },
                    },
                };
                const s_item2 = {
                    name: item.workorder_type_name,
                    value: item.duration,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        normal: {
                            show: true,
                            position: "inner", // 数值显示在内部
                            formatter: "{d}%",
                            color: "#ffffff",
                        },
                    },
                };
                sData.push(s_item);
                sData2.push(s_item2);
            });
            this.getEchartsPie(id, sData, sData2, color, tooltipName);
        },
        getEchartsPie(id, sData, sData2, color, tooltipName) {
            var dom = document.getElementById(id);
            var myChart = echarts.init(dom);
            myChart.clear();
            var option;
            var that = this;
            option = {
                color,
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "#fffffff",
                    padding: 12,
                    formatter: function (params) {
                        let html = "";
                        html += `<div class="custom_chart_tooltip"><p class="tooltip_title"><span>${params.name}</span></p><p class="tooltip_content"><span class="chart_circle_item"><i class="chart_circle" style="background: ${params.color}"></i>${tooltipName}</span><span class="count">${params.percent}%</span></p></div>`;
                        return html;
                    },
                },
                legend: {
                    show: false,
                    icon: "rect",
                    itemWidth: 10,
                    itemHeight: 8,
                    borderRadius: 2,
                    textStyle: {
                        fontSize: 14, // 设置图例文本的字体大小为 16 像素
                        padding: [5, 0, 5, 0],
                    },
                    left: 0,
                    itemGap: 10,
                    top: 0,
                },
                left: "center",
                top: 45,
                right: 0,
                left: 0,
                bottom: 0,
                series: [
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 50,
                        top: 30,
                        labelLine: {
                            length: 15,
                            showAbove: true,
                            lineStyle: {
                                color: "rgba(0, 0, 0, 0.25)",
                            },
                        },
                        data: sData,
                    },
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 50,
                        top: 30,
                        data: sData2,
                    },
                ],
            };
            option && myChart.setOption(option, true);
            this["myChartPie" + id] = myChart;
            // this.handleResizePie();
            // window.addEventListener("resize", this.handleResizePie);
        },
        handleResize() {
            if (this.resizeHandler) {
                clearTimeout(this.resizeHandler);
            }
            this.resizeHandler = setTimeout(() => {
                if (this.myChartBar) {
                    this.myChartBar.resize();
                }
            }, 100);
        },
        handleResizeLine() {
            if (this.resizeHandlerLine) {
                clearTimeout(this.resizeHandlerLine);
            }
            this.resizeHandlerLine = setTimeout(() => {
                if (this.myChartLine) {
                    this.myChartLine.resize();
                }
            }, 100);
        },
    },
};
</script>
<style lang="scss" scoped>
.van-dropdown-menu {
    ::v-deep {
        .van-dropdown-menu__bar {
            box-shadow: none;
            padding: 6px 16px;
        }
        .van-dropdown-menu__item {
            width: 100%;
            border-radius: 6px;
            background: #f7f8fa;
            opacity: 1;
            display: flex;
            justify-content: space-between;
            padding: 0 12px;
        }
        .van-dropdown-menu__title--active {
            color: #333333;
            font-weight: 700;
            font-size: 14px;
            flex: 1;
        }
        .van-dropdown-menu__title {
            padding: 0;
            width: 100%;
            color: #333333;
            font-weight: 700;
            font-size: 14px;
        }
        .van-dropdown-menu__title::after {
            right: 4px;
            opacity: 1;
            font-size: 16px;
            color: #666666;
            font-weight: 700;
            border-color: transparent transparent #666666 #666666;
        }
        .van-overlay {
            background-color: rgba(0, 0, 0, 0.3);
        }
        .van-dropdown-item--down {
            .van-dropdown-item__option {
                text-align: center;
            }
            .van-cell {
                font-size: 16px;
                color: #666666;
            }
            .van-cell__value {
                flex: 0;
            }
        }
    }
}
.mobile_container {
    padding: 10px 16px;
}
.item_card_wrap {
    position: relative;
    flex: 1;
    padding: 16px 0 0 12px;
    p:nth-child(1) {
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 28px;
    }
    p:nth-child(2) {
        margin-top: 4px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
    }
}
.statistics_item_wrap {
    width: 100%;
    height: 82px;
    opacity: 1;
    border-radius: 6px;
    background: url("https://download.hecoos.com/enlightv/2025-10/802f1d073f6ffbfed9ff72e98707eb4b.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    & > div:nth-child(2),
    & > div:nth-child(3) {
        &::after {
            content: "";
            position: absolute;
            left: -1px;
            top: 16px;
            width: 1px;
            height: 50px;
            background-color: rgba(0, 0, 0, 0.08);
        }
    }
    .item_card_wrap {
        p:nth-child(1) {
            color: #2990ff;
        }
        p:nth-child(2) {
            color: #666666;
        }
    }
}
.statistics_flex_wrap {
    margin-top: 10px;
    width: 100%;
    height: 82px;
    opacity: 1;
    display: flex;
    gap: 10px;
    .item_card_wrap {
        p:nth-child(2) {
            color: #666666;
        }
    }
    .item_card_wrap:nth-child(1) {
        background: url("https://download.hecoos.com/enlightv/2025-10/e1715b98cff661bfbce49b03e976e513.png") no-repeat;
        background-size: 100% 100%;
        p:nth-child(1) {
            color: #f0aa32;
        }
    }
    .item_card_wrap:nth-child(2) {
        background: url("https://download.hecoos.com/enlightv/2025-10/8c1d2382be8f690bdc7bc211180c537a.png") no-repeat;
        background-size: 100% 100%;
        p:nth-child(1) {
            color: #5ab333;
        }
    }
}
.chart_box_item {
    margin-top: 10px;
    min-height: 120px;
    height: auto;
    padding: 12px 0 0;
    border-radius: 6px;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    .chart_box_item_title {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        padding-left: 12px;
        color: rgba(51, 51, 51, 1);
        position: relative;
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 2px;
            height: 22px;
            opacity: 1;
            border-radius: 0px 3px, 4px, 0px;
            background: #2990ff;
        }
    }
    &.chart_box_item1,
    &.chart_box_item3 {
        height: 202px;
    }
    &.chart_box_item2,
    &.chart_box_item4 {
        height: 272px;
    }
    .chart_box_item_bottom {
        width: 100%;
        height: calc(100% - 22px);
        position: relative;
    }
    .echarts_container {
        width: 100%;
        height: 100%;
    }
}
</style>
<style lang="scss">
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    box-shadow: 0px 2px 4px #0000003f;
    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
    }
    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.65);
        display: flex;
        justify-content: space-between;
        gap: 24px;
        .count {
            font-weight: 500;
        }
        .chart_circle_item {
            display: flex;
            align-items: center;
            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>
